import React, { Component } from "react";
import { browserHistory } from "react-router";
import "./Footer.css";
import packageFile from "../../../../package.json";

class Footer extends Component {
  render() {
    const location = this.props.location;
    return (
      <footer
        className={
          location === "/" ||
          location === "/login" ||
          location === "/signup" ||
          location === "/forget-password"
            ? ""
            : "RelativeFooter"
        }
      >
        © ۱۳۹۸ - هر گونه کپی برداری غیر مجاز است.
        <span
          className="revision"
          onClick={() => browserHistory.push("/page/last-change")}
        >
          {packageFile.version}
        </span>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Common/Footer/Footer.js